module.exports = __webpack_public_path__ + "static/img/index_banner.0357d01d.png";